export const Origin = {
  MENTAL: 'MentalHealth',
  MENTAL_FU: 'MentalHealthFollowup',
  PRIMARY: 'Default',
  FU: 'Followup',
  HTN: 'Hypertension',
  HTN_FU: 'HypertensionFollowup',
  DIABETES: 'Diabetes',
  DIABETES_FU: 'DiabetesFollowup',
  RISK_ASSESSMENT: 'RiskAssessment',
  MENTAL_KIDS: 'MentalHealthKids',
  PEDIATRICK: 'Pediatric'
}

export const Variant = {
  MENTAL: 'mh',
  MENTAL_FU: 'mh_fub',
  PRIMARY: 'default',
  FU: 'fub',
  HTN: 'htn',
  HTN_FU: 'htnFollowup',
  DIABETES: 'dm',
  DIABETES_FU: 'dmFollowup',
  RISK_ASSESSMENT: 'risk_assessment',
  PEDIATRICK: 'pediatric'
}
